// import React from "react";
import { useState, useEffect } from "react";
import { fget } from "../../../API/callsAPI";
import SingleComment from "../../Utilities/Comments/SingleComment";
import useStyles from "../SequencerOverview/SequencerMixNewStyles";
import { CircularProgress, Button, Modal, IconButton } from "@mui/material";
import { Plus, X } from "phosphor-react";

const SequencerChats = ({ selectedVersion, loggedInUser, refreshCounter, embedded }) => {
  const classes = useStyles();
  const [commentsPageNo, setCommentsPageNo] = useState(1);
  const [commentsList, setCommentsList] = useState({
    data: [],
    loading: true,
    isNextAvailable: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [displayImage, setDisplayImage] = useState(null);

  const fetchComments = async () => {
    setIsLoading(true);
    try {
      let url = `trackables/trackable-comment/?version_id=${selectedVersion?.shotVersion.id
        }&version_type=${"shotversion"}&page=${commentsPageNo}&ordering=-created_at`;

      const commentsRes = await fget({
        url: url,
      });
      setCommentsList({
        data: commentsRes.data.results,
        loading: false,
        isNextAvailable: commentsRes.data.is_next_available,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedVersion?.shotVersion) {
      fetchComments();
    }
  }, [commentsPageNo, selectedVersion?.shotVersion, refreshCounter]);

  //make get request
  return (
    <div
      className={
        embedded ? classes.commentsContainerEmbedded : classes.commentsContainer
      }
    >
      {isLoading ? (
        <div className={classes.loadingContainer}>
          <CircularProgress />
        </div>
      ) : (
        <>
          {commentsList.data.map((eachComment) => {
            return (
              <div
                style={{
                  padding: "12px 14px",
                  borderBottom: "1.8px solid #252A38",
                  boxSizing: "border-box",
                  height: "max-content",
                }}
              >
                <SingleComment
                  eachComment={eachComment}
                  key={eachComment?.id}
                  setDisplayImage={setDisplayImage}
                  setOpen={setOpen}
                />
              </div>
            );
          })}
          <div
            className={classes.flexCenter}
            style={{
              display: commentsList?.isNextAvailable ? "flex" : "none",
            }}
          >
            <Button
              className={classes.showMoreButton}
              onClick={() => setCommentsPageNo(commentsPageNo + 1)}
              startIcon={<Plus />}
            >
              See More
            </Button>
          </div>
        </>
      )}
      <Modal open={open} style={{ display: "flex", justifyContent: "center", alignItems: "center" }} onClose={() => setOpen(false)}>
        <div style={{ height: "85%", width: "85%", padding: "5px", display: "flex", flexDirection: "column", backgroundColor: "#252A38" }}>
          <IconButton onClick={() => setOpen(false)} style={{ alignSelf: "flex-end" }}><X color="black" size={30} /></IconButton>
          <img src={displayImage} alt="displayImage" height="100%" width="100%" />
        </div>
      </Modal>

    </div>
  );
};

export default SequencerChats;
